import(/* webpackMode: "eager", webpackExports: ["ErrorPage"] */ "/app/app/[locale]/[...not-found]/error-page.tsx");
